import React, { useState } from 'react';
import { Tabs, Tab, Row, Col } from 'react-bootstrap';
import OsColumns from './osColumns';
import './osWidget.scss';

function OsPlansWidget() {
    const [key, setKey] = useState('one');

    return (
        <div className="os-plans-columns-wrapper">
            <Row className="mb-3">
                <Col md={12} className="text-center">
                    <Tabs id="plans-tabs" activeKey={key} onSelect={(k) => setKey(k)}>
                        <Tab eventKey="one" title="">
                            <OsColumns />
                        </Tab>
                    </Tabs>
                </Col>
            </Row>
        </div>
    );
}

export default OsPlansWidget;
